import { render, staticRenderFns } from "./RedemptionsUnavailableBanner.vue?vue&type=template&id=9d086170"
import script from "./RedemptionsUnavailableBanner.vue?vue&type=script&lang=js"
export * from "./RedemptionsUnavailableBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports